import { render, staticRenderFns } from "./detailTab.vue?vue&type=template&id=eb79cf80&scoped=true"
import script from "./detailTab.vue?vue&type=script&lang=js"
export * from "./detailTab.vue?vue&type=script&lang=js"
import style0 from "./detailTab.vue?vue&type=style&index=0&id=eb79cf80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb79cf80",
  null
  
)

export default component.exports